import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['counter', 'label', 'input', 'submit']

  connect(){
    const delay = 300
    let timer = 0
    this.inputTarget.addEventListener('keyup', () => {
      clearTimeout(timer)
      timer = setTimeout(() => {this.update()}, delay)
    })
    this.update()
  }

  update(){
    const required = parseInt(this.data.get('required'))
    let remaining = required, text = this.inputTarget.value

    if (text && text.length > 0 && text.match(/\S+/g)){
      remaining = required - text.match(/\S+/g).length
    }

    if (remaining > 0) {
      this.counterTarget.innerText = remaining
      this.labelTarget.classList.remove('o-0')
      this.submitTarget.disabled = true
    } else {
      this.labelTarget.classList.add('o-0')
      this.submitTarget.disabled = false
    }
  }
}
